import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { propArrayShape, propStr, propNumber, } from '../../../../../../helpers/custom-prop-types';
import Image from '../../../../Common/Image';
/**
 * スライド共有したメンバーを表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareItemMembers = (props) => {
    const { className, limit, members: rawMembers } = props;
    const { hiddenCount, members } = useMemo(() => {
        const viewableMembers = rawMembers.slice(0, limit);
        return {
            hiddenCount: rawMembers.length - viewableMembers.length,
            members: viewableMembers,
        };
    }, [rawMembers, limit]);
    return (_jsxs("div", Object.assign({ className: clsx('slide_search_share_item_members', className) }, { children: [_jsx("ul", Object.assign({ className: 'members_list' }, { children: members.map((v) => (_jsx("li", Object.assign({ className: 'member_item' }, { children: _jsx(Image, { allowContextMenu: false, alt: '', className: 'member_thumbnail', isObjectFit: true, noImageType: 'user', src: v.photo, useImage: true }) }), v.id))) })), hiddenCount > 0 && (_jsx("div", Object.assign({ className: 'members_count' }, { children: _jsx("span", Object.assign({ className: 'count_text' }, { children: `+${hiddenCount}人` })) })))] })));
};
SlideSearchShareItemMembers.propTypes = {
    className: propStr(),
    limit: propNumber(),
    members: propArrayShape().isRequired,
};
SlideSearchShareItemMembers.defaultProps = {
    className: '',
    limit: 2,
};
export default SlideSearchShareItemMembers;
